class BDSubscriptions extends HTMLElement {
  connectedCallback() {
    this.discount = Number(this.dataset.discount || 0);

    this.oneTime = this.querySelector(
      'input[name="purchase_type"][value="one_time"]',
    );
    this.subscribe = this.querySelector(
      'input[name="purchase_type"][value="subscribe"]',
    );
    this.select = this.querySelector('select[name="selling_plan"]');

    this.productContainer = this.closest('[data-product-id]');
    if (!this.productContainer) return;

    this.capturePriceElements();
    if (!this.oneTime || !this.subscribe || !this.select) return;

    this.oneTime.addEventListener('change', () => {
      this.select.value = '';
      console.log('reset pricing');
      this.resetPricing();
    });

    this.subscribe.addEventListener('change', () => {
      this.select.selectedIndex = 0;
      console.log('apply discount');
      this.applyDiscount();
    });

    requestAnimationFrame(() => this.initializePricing());

document.addEventListener('product:variant-change', (event) => {
  console.log('SubsVariantChangeEvent');

  const { variant } = event.detail || {};
  if (!variant) return;

  this.currentVariant = variant; // ← store it

  const base = variant.price / 100;
  console.log('Variant base price:', base);

  // Update DOM with the new base price
  if (this.priceRegular) this.priceRegular.textContent = this.formatMoney(base);
  if (this.priceSale) this.priceSale.textContent = this.formatMoney(base);

  // Re-run subscription logic
  this.initializePricing();
});


  }

  capturePriceElements() {
    console.log('capturePriceElements');

    const root =
      this.productContainer.querySelector('.price') ||
      this.productContainer.querySelector('[id^="price-"]') ||
      this.productContainer;

    this.priceRegular = root.querySelector('.price__regular .money');
    this.priceSale = root.querySelector(
      '.price__sale .price-item--sale .money',
    );
    this.priceStrike = root.querySelector('.price__sale s.price-item--regular');
    this.priceContainer = root.querySelector('.price__container');
  }

 getBasePrice() {
  if (this.currentVariant) {
    return this.currentVariant.price / 100;
  }
  const raw = this.priceRegular.textContent.replace(/[^0-9.]/g, '');
  return Number(raw);
}


  formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  applyDiscount() {
    if (!this.discount) return;

    const base = this.getBasePrice();
    const discounted = base - base * (this.discount / 100);

    this.priceContainer?.classList.add('price--on-sale');

    if (this.priceStrike) {
      this.priceStrike.textContent = this.formatMoney(base);
    }

    if (this.priceSale) {
      this.priceSale.textContent = this.formatMoney(discounted);
    }

    this.productContainer.classList.add('has-subscription-sale');

    console.log('subs sale price', discounted);
  }

  resetPricing() {
    const base = this.getBasePrice();
    console.log('base price', base);

    this.priceContainer?.classList.remove('price--on-sale');

    if (this.priceStrike) {
      this.priceStrike.textContent = '';
    }

    if (this.priceSale) {
      this.priceSale.textContent = this.formatMoney(base);
    }

    this.productContainer.classList.remove('has-subscription-sale');
  }

  initializePricing() {
    console.log('initialize pricing');

    const hasSellingPlan = this.select.value !== '';
    const isSubscribeChecked = this.subscribe.checked;

    if (isSubscribeChecked || hasSellingPlan) {
      if (hasSellingPlan) this.subscribe.checked = true;
      this.applyDiscount();
    } else {
      this.resetPricing();
    }
  }
}

customElements.define('bd-subscriptions', BDSubscriptions);
